'use strict';

require('../../picker-view/style/');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/picker/style/index.js
// module id = 672
// module chunks = 0